// apps/web/src/components/landing-v2/proofs/ReadingRevisitedProof.tsx
/** Theme 03 / Add a note, months later — a saved reading with a follow-up
 *  reflection box.  Reference: handoff "Re-reading older threads" .mm. */
export function ReadingRevisitedProof() {
  return (
    <div className="absolute inset-0 flex flex-col p-[18px]">
      <p className="text-[10px] uppercase tracking-[0.22em] text-text-muted">
        Three months ago
      </p>
      <div
        className="mt-1.5 border-l-2 pl-2.5"
        style={{ borderColor: 'color-mix(in oklab, var(--color-gold-light-legacy) 40%, transparent)' }}
      >
        <div
          className="font-display italic text-text-primary"
          style={{ fontSize: '0.88rem' }}
        >
          &ldquo;What am I avoiding?&rdquo;
        </div>
        <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-text-muted">
          August 12 · The Tower · Upright
        </div>
      </div>

      <div
        className="mt-3 rounded-lg border border-dashed p-2.5"
        style={{
          background: 'color-mix(in oklab, var(--color-astral-violet) 8%, transparent)',
          borderColor: 'color-mix(in oklab, var(--color-astral-violet) 30%, transparent)',
        }}
      >
        <div className="text-[10px] uppercase tracking-[0.22em] text-astral-violet-light">
          Now, looking back
        </div>
        <div
          className="mt-1 font-display italic text-text-primary"
          style={{ fontSize: '0.78rem' }}
        >
          &ldquo;It was the conversation about Dad. I had it three weeks later.&rdquo;
        </div>
      </div>

      <div className="mt-auto flex gap-1.5 pt-2">
        <span className="rounded-pill border border-astral-violet/30 bg-astral-violet/[0.16] px-2 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-astral-violet-light">
          Add a note
        </span>
        <span
          className="rounded-pill px-2 py-1 text-[10px] uppercase tracking-[0.14em] text-text-muted"
          style={{
            background: 'var(--hairline-faint)',
            border: '1px solid var(--hairline)',
          }}
        >
          Pull again
        </span>
      </div>
    </div>
  )
}
